export class ApiEndPointsForms {
    getLoggedInUserDetailsManageUser = 'api/ManageUser/GetUserProfileDetail';
    getUserOffices = 'api/ManageUser/GetUserOffices';
    validateUser = 'api/Auth/ValidateToken';
    CreateProjectFromFormLink = "api/CoreDocument/CreateProjectFromFormLink";
    getFormFolderList = 'api/FormFolder/GetFormFolder';
    getFormFolderSharedWithMe = 'api/FormFolder/GetFormFolderSharedWithMe';
    getFormFolderWithFormTemplatesSharedWithMe = 'api/FormFolder/GetFormFolderWithFormTemplatesSharedWithMe'; //'api/FormFolder/GetFormFolderWithFormTemplates';
    getFileManagerFolders = "api/FileManager/GetFileManagerFolders";
    GetParentFormFolderHierarchy = 'api/FormFolder/GetParentFormFolderHierarchy';
    getFormFolderWithFormTemplates = 'api/FormFolder/GetFormFolderWithFormTemplates';
    GetFormFolderDetail = 'api/FormFolder/GetFormFolderDetail';
    GetFormDetail = 'api/FormFolder/GetFormDetail';
    AddFormFolder = 'api/FormFolder/AddFormFolder';
    AddFormTouch = 'api/FormTouch/AddFormTouch';
    GetAllFormTouches = "api/FormTouch/GetAllFormTouches";
    RenameFormFolder = 'api/FormFolder/RenameFormFolder';
    RenameForm = 'api/FormFolder/RenameForm';
    DeleteFormFolder = 'api/FormFolder/DeleteFormFolder';
    ShareFormFolder = 'api/FormFolder/ShareFormFolder';
    ShareForm = 'api/FormFolder/ShareForm';
    DeleteFormItems = 'api/FormFolder/DeleteFormItems';
    GetAllFormSharedTo = 'api/FormFolder/GetAllFormSharedTo';
    ModifyShareFormFolder = 'api/FormFolder/ModifyShareFormFolder';
    ModifyShareForm = 'api/FormFolder/ModifyShareForm';
    GetAllFromFolderSharedRole = 'api/Contact/GetAllFromFolderSharedRole';
    AddFormFavorite = 'api/FormFavorite/AddFormFavorite';
    DeleteFormFavorite = 'api/FormFavorite/DeleteFormFavorite';
    AddEditProjectGroup = 'api/Project/AddEditProjectGroup';
    //GetFormTemplateCategories ='api/Project/GetFormTemplateCategories';
    GetGroupList = 'api/Project/GetGroupList';
    AddRecentlyViewFolder = 'api/FormFolder/AddRecentlyViewFolder';
    GetRecentlyViewFolders = 'api/FormFolder/GetRecentlyViewFolders';
    AddProjectStepFirst = 'api/Project/AddProjectStepFirst';
    CheckIfPDFWillConvertToImage = 'api/Project/CheckIfPDFWillConvertToImage';
    AddProjectStep2 = 'api/Project/AddProjectStep2';
    AddParticipantJsonStep3 = 'api/Project/AddParticipantJsonStep3';
    UploadBlankImageToFormOrProject = 'api/Project/UploadBlankImageToFormOrProject';
    GeneratePDF = 'api/Project/GeneratePDF';
    GetProjectDocuments = 'api/Project/GetProjectDocuments';
    UpdatePartcipantMessage = 'api/Project/UpdatePartcipantMessage';
    getAttachment = 'api/App/DownloadDocument';
    RemoveDashboardFavoriteItem  = 'api/App/RemoveDashboardFavoriteItem ';
    getTransactinalRoles = 'api/Contact/GetTransactinalRoles';
    AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
    UpdateParticipantDeatil = 'api/Project/UpdateParticipantDeatil';
    GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
    getSharedAccesslRoles = 'api/ManageRole/GetAllRolesToLinkContactCompanyCore';
    RemoveGroupRelation = 'api/Project/RemoveGroupRelation';
    ReorderFormGroupRelations = 'api/Project/ReorderFormGroupRelations';
    getDraftedProjects = "api/Project/GetDraftedProjects";
    GetProjectFormEditorDetails = "api/Project/GetProjectFormEditorDetail";
    AddProjectInfoAsTemplete = "api/Project/AddProjectInfoAsTemplete";
    GetTaskGroupsByTaskList = "api/Task/GetTaskGroupsByTaskList";//"api/Task/GetTaskByTaskList";
    GetExterURLToken = "api/auth/GetExterURLToken";
    GetTemplateByID = "api/TaskList/GetTemplateByID";
    AddTask3c = "api/TaskList/AddTask3c";
    SendExternalURLEmail = "api/auth/SendExternalURLEmail";
    UpdateTaskOrTaskListstatus = "api/Task/UpdateTaskOrTaskListstatus";
    UpdateSingleTaskStatus = "api/Task/UpdateSingleTaskStatus";
    UpdateTaskPriority = "api/Task/UpdateTaskPriority"
    CheckProjectNames = 'api/Project/CheckProjectName';
    CheckProjectTemplateName = 'api/Project/CheckProjectTemplateName';
    AddmessageStep4 = 'api/Project/AddmessageStep4';
    DeleteDraftedprojects = 'api/Project/DeleteDraftedProject';
    searchFormFolders = 'api/FormFolder/SearchFormFoldersWithTemplates';
    DeletePrivateMessage = 'api/Project/DeletePrivateMessage';
    getInboxProjects = "api/Project/GetInboxProjects";
    getSentProjects = "api/Project/GetSentBoxItems";
    deleteInboxSentProjects = "api/Project/DeleteInboxOrSentItems";
    getParticipantJson = "api/Project/GetParticipantJson";
    GetSignNowJson = "api/Project/GetSignNowJson";
    getTabularJson = "api/Project/getTabularJson";
    updateParticipantJson = "api/Project/UpdateParticipantJson";
    SaveSigningParticipantJson = "api/Project/SaveSigningParticipantJson";
    SaveSignNowDocuments = "api/Project/SaveSignNowDocuments";
    UpdateTabularJson = "api/Project/UpdateTabularJson";
    MakeCopyOfFormTemplate = "api/Project/MakeCopyOfFormTemplate";
    GetProjectParticicpantWithSigningLinkByProjectID = "api/Project/GetProjectParticicpantWithSigningLinkByProjectID";
    MakeMasterCopyOfFormTemplate = "api/Project/MakeCopyOfMasterFormTemplate";
    ChangeFormFolders = "api/Project/ChangeFormFolders";
    GetSentBoxItemParticipantList = "api/Project/GetSentBoxItemParticipantList";
    moveSentProjectsToTrash = "api/Project/DeleteSentProjects";
    EditParticipantEmail = "api/Project/EditParticipantEmail";
    remindParticipant = "api/Project/SendReminderToParticipant";
    ResendEmail = "api/Project/ResendEmail";
    ResendRemainderProjectReport = "api/Project/ResendRemainderProjectReport";
    ReopenSignatureLink = "api/Project/ReopenSignatureLink";
    GetTrashBoxItems = "api/Project/GetTrashBoxItems";
    DeleteInboxProjects = "api/Project/DeleteInboxProjects";
    DeleteSentProjects = "api/Project/DeleteSentProjects";
    RenewProject = "api/Project/RenewProject";
    RetryPdfToImage = "api/Project/RetryPdfToImage";
    CompressPDF = "api/Project/CompressPDF";
    ReplaceExistingPDF = "api/Project/ReplaceExistingPDF";
    AddAIDocuments = "api/AIChat/AddAIDocuments";
    GetResponseFromAIDoc = "api/AIChat/GetResponseFromAIDoc";
    GetAIDocuments = "api/AIChat/GetAIDocuments";
    DeleteAIDocuments = "api/AIChat/DeleteAIDocuments";
    GetPageCount = "api/Project/GetPageCount";
    AddProjectAttachmentDocument = "api/Project/AddProjectAttachmentDocument";
    GetInBoxItemParticipantList = "api/Project/GetInBoxItemParticipantList";
    UseFormsTemplateForProject = "api/Project/UseFormsTemplateForProject";
    MergeTemplate = 'api/Project/MergeTemplate';
    UseMasterTemplateForProject = "api/Project/UseMasterTemplateForProject";
    FileManagerFoldersWithHierarchy = "api/FileManager/FileManagerFoldersWithHierarchy";
    GetContactDetailForAutoFill = "api/Contact/GetContactDetailForAutoFill";
    GetCoreDetailForAutoFill = "api/Core/GetCoreDetailForAutoFill";
    declineForm = "api/Project/SendParticiantDecline";
    FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
    getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
    RequestCoreUrlVisit = "api/CoreDocument/RequestContactUrlVisit";
    RequestContactUrlVisit = "api/ContactDocument/RequestContactUrlVisit";
    RequestCompanyUrlVisit = "api/CompanyDocument/RequestContactUrlVisit";
    ParticipantDocumentUploadCore = "api/CoreDocument/ParticipantDocumentUpload";
    ParticipantDocumentUploadContact = "api/ContactDocument/ParticipantDocumentUpload";
    ParticipantDocumentUploadCompany = "api/CompanyDocument/ParticipantDocumentUpload";
    AddProjectEventLog = "api/Project/AddProjectEventLog";
    GetProjectAuditLog = "api/Project/GetProjectAuditLog";
    NotificationPost = "api/Notification/Post";
    NotificationList = "api/Notification/GetNotificationDetails";
    GetUnreadNotificationsCount = "api/Notification/GetUnreadNotificationsCount";
    MarkUnreadNotifications = "api/Notification/MarkUnreadNotifications";
    AddHtMLForm = "api/Project/AddHtmlForm";
    UpdateHTMLForm = "api/Project/UpdateHTMLForm";
    searchTransCities = "api/app/SearchCities";
    searchTransZip = "api/app/SearchZipCode";
    getStateList = "api/Orgnization/GetStateValues";
    getDashboardStats = "api/App/DashboardStats";
    getDashboard3cGraphData = "api/App/GetDashboard3cGraphData";
    DashboardFavoriteItems = "api/App/DashboardFavoriteItems";
    AddDashboardFavoriteItem = "api/App/AddDashboardFavoriteItem";
    getDashboardSignatureGraphData = "api/App/GetDashboardSignatureGraphData";
    addNote = "api/Note/AddNote";
    getNotes = "api/Note/GetNotes";
    deleteNotes = "api/Note/DeleteNote";
    deletePortalNotes = "portalapi/Portal/DeletePersonalNote";
    getCoreListing = "api/Core/GetCores";
    getContactListing = "api/Contact/GetContacts";
    getCompanyListing = "api/Company/GetCompanies";
    GetSharedWithMeFileManager = "api/FileManager/GetSharedWithMeFileManager";
    GetSharedWithMeFileManagerWithHierarchy = "api/FileManager/GetSharedWithMeFileManagerWithHierarchy";
    getFormTemplateCategories = "api/Project/GetFormTemplateCategories";
    updateProjectGroupRelationName = "api/Project/UpdateProjectGroupRelationName";
    getProjectFinalDocuments = "api/Project/GetProjectFinalDocuments";
    generateFinalDocumentsThroughSignaturePage = "api/Project/GenerateFInalDocumentsThroughSignaturePage";
    GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality = "api/Project/GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality";
    projectFinishBySender = "api/Project/ProjectFinishBySender";
    getFormHtml = "api/Project/GetFormHtml";
    getHtmlFormData = "api/Project/GetHtmlFormData";
    GetProjectsByFormID = "api/Project/GetProjectsByFormID";
    DownloadMultipleAsZipAsync = "api/Project/DownloadMultipleAsZip";
    FetchDocAsync = "api/Project/FetchDocFromAzureBlobStorage";
    SubmitHTMLForm = "api/Project/SubmitHTMLForm";
    addTasklist = "api/TaskList/AddTasklist";
    renameTasklist = "api/TaskList/RenameTasklist";
    getOrganizationFormTemplateGallery = "api/Project/GetOrganizationFormTemplateGallery";

    addSignature = "api/PublicUser/AddSignature";
    addInitial = "api/PublicUser/AddInitial";
    saveAIChatHistory = "api/AIChat/AddAIChatHostory";
    getAllAIChatHistory = "api/AIChat/GetAllAIChatHostory";
    getSignaturesAndInitials = "api/PublicUser/GetSignaturesAndInitials";
    removeSignature = "api/PublicUser/RemoveSignature";
    removeInitial = "api/PublicUser/RemoveInitial";

    addDefaultSignature = "api/PublicUser/ChangeDefaultSignature";
    changeDefaultInitial = "api/PublicUser/ChangeDefaultInitial";
    addFileManagerFile = "api/FileManager/AddFileManagerFiles";
    verifyFileManagerFolderUrl = "api/FileManager/VerifyFileManagerFolderUrl"

    isCheckIn = "api/Project/IsCheckIn";
    archivedTemplateUrlSentLog = "api/TaskList/ArchivedTemplateUrlSentLog";
    GetFileManagerFileDetail = "api/FileManager/GetFileManagerFileDetail";
    AddVectorFileID = "api/FileManager/AddVectorFileID";
    GetOCRJSonDataByURL = "api/FileManager/GetOCRJSonDataByURL";
    DownloadDocument = "api/FileManager/DownloadDocument";
    getPortalDatafor3C="portalapi/Portal/GetPortalDatafor3C";
    getOfficeDetail = "api/Orgnization/GetOfficeDetail";
    getPortalUser3Cs="portalapi/Portal/GetPortalUser3Cs";
    CheckLoginTokenEXpiry = 'api/Auth/CheckLoginTokenEXpiry';
    addNotePortal = "portalapi/Portal/AddNote";
    addPersonalNote = "portalapi/Portal/AddPersonalNote";
    getPortalDataforHome= "portalapi/Portal/GetPortalDataforHome";
    getPortalBroadcastingMessages= "portalapi/Portal/GetPortalBroadcastingMessages";
    getPortalUnreadNotifications= "portalapi/Portal/GetPortalUnreadNotifications";
    getCompletedActionsfor3C= "portalapi/Portal/GetCompletedActionsfor3C";   
    readNotification="portalapi/Portal/ReadNotification";
    getThirdPartyApis = "api/ThirdPartyApis/GetThirdPartyApis";
    addCoreMultiDocumentFromPortal = "api/CoreDocument/AddCoreMultiDocumentFromPortal";
    adContactMultiDocumentFromPortal = "api/ContactDocument/AddContactMultiDocumentFromPortal";
    addCompanyMultiDocumentFromPortal = "api/CompanyDocument/AddCompanyMultiDocumentFromPortal";

    uploadCoreDocument = "api/CoreDocument/UploadCoreDocument";
    uploadContactDocument = "api/ContactDocument/UploadContactDocument";
    uploadCompanyDocument = "api/CompanyDocument/UploadCompanyDocument";
    formShareOnPortal = "api/FormFavorite/FormShareOnPortal";
    getPortalFormsforHome="portalapi/Portal/GetPortalFormsforHome";
    GetRelationByTaskTemplateID = 'api/Project/GetRelationByTaskTemplateID';
    searchCore = "api/Core/SearchCore";
    searchContact = "api/Contact/SearchContacts";
    searchCompany = "api/Company/SearchCompanies";
    getSynonyms = "api/Core/GetSynonyms";
    getOCRTemplateCategories = "api/OCRTemplate/GetOCRTemplateCategories";
    getOCRModels = "api/OCRTemplate/GetOCRModels";
    extractDataWithFields = "api/FileManager/ExtractDataWithFields";
    addOcrTemplate = "api/OCRTemplate/AddOCRTemplate";
    getOCRTemplates = "api/OCRTemplate/GetOCRTemplates";
    getOCRTemplateFields = "api/OCRTemplate/GetOCRTemplateFields";
    addMappedKeyValueData = "api/FileManager/AddMappedKeyValueData";
    getAllFieldsForAITool= "api/Core/GetAllFieldsForAITool";
    addField = "api/Core/AddField";
    SearchFieldName = "api/Core/SearchFieldName";
    getFieldDetailForTab = "api/Core/GetFieldDetailForTab";
    AddFieldFolderMappingForExistingField = "api/Core/AddFieldFolderMappingForExistingField";
    getNLPTemplateCategories="api/NLPTemplate/GetNLPTemplateCategories";
    addNLPTemplate="api/NLPTemplate/AddNLPTemplate";
    getNLPTemplates="api/NLPTemplate/GetNLPTemplates";
    getNLPQueries="api/NLPTemplate/GetNLPQueries";
    renameNLPTemplate="api/NLPTemplate/RenameNLPTemplate";
    activateNLPTemplate="api/NLPTemplate/ActivateNLPTemplate";
    removeNLPTemplates="api/NLPTemplate/RemoveNLPTemplates";
    updateNLPTemplate="api/NLPTemplate/UpdateNLPTemplate";
    mergePdfFiles="api/FileManager/MergePdfFiles";
    getCoreFeildList = "api/Core/GetAllFolderFields";
    SendMedicationToCore = "api/Core/SendMedicationToCore";
    SendPromptsToCore = "api/Core/SendPromptsToCore";
    manageFormUrlFields="api/Project/ManageFormUrlFields";
    GetFileItemsByProjectId="api/Project/GetFileItemsByProjectId";
    manageProjectUrlFields="api/Project/ManageProjectUrlFields";
    manageProjectFolderUrlParams="api/Project/ManageProjectFolderUrlParams";
    manageFormFolderUrlParams="api/Project/ManageFormFolderUrlParams";
    addFileAIPrompt="api/FileManager/AddFileAIPrompt";
    getFileAIPrompt="api/FileManager/GetFileAIPrompts";
    GetAllSystemPrompt="api/NLPTemplate/GetAllSystemPrompt";
    removeFileAIPrompts="api/FileManager/RemoveFileAIPrompt";
    disableUrlParameterConfiguration="api/Project/DisableUrlParameterConfiguration";
    disableFolderUrlParameterConfiguration="api/Project/DisableFolderUrlParameterConfiguration";
    disableSignaturePageAutofill="api/Project/DisableSignaturePageAutofill";
    configureFormFolderUrls="api/FormFolder/ConfigureFormFolderUrls";
    matchFormFolderUrlParameter="api/Project/MatchFormFolderUrlParameter";
    addWebFormUserSetting="api/Project/AddWebFormUserSetting";
    getPDFFormReport="api/Project/GetPDFFormReport";
    addPDFFormUserSetting="api/Project/AddPDFFormUserSetting";
    mapCoreContactWithFinalDocuments="api/Project/MapCoreContactWithFinalDocuments";
    getFormsList="api/FormFolder/GetFormsList";
    userList = 'api/ManageUser/GetUserList';
    pdfProjectAdvancedSearch = "api/Project/PdfProjectAdvancedSearch";
    AddCreateProjectforPlaceholderCore = "api/CoreDocument/AddCreateProjectforPlaceholder";
    AddCreateProjectforPlaceholderContact = "api/ContactDocument/AddCreateProjectforPlaceholder";
    AddCreateProjectforPlaceholderCompany = "api/CompanyDocument/AddCreateProjectforPlaceholder";
    reorderFileAIPrompt="api/FileManager/ReorderFileAIPrompt";
    resendEmailtoParticipants="api/Project/ResendEmailtoParticipants";
    prepareOCRFiles="api/AIAutomation/PrepareOCRFiles";
    GetGoogleGeminiResponseGetQuestionAIResponse="api/AIAutomation/GetGoogleGeminiResponseGetQuestionAIResponse";
    GetGoogleGeminiResponseFieldsValuesforNLP="api/AIAutomation/GetGoogleGeminiResponseFieldsValuesforNLP";
    pushMergedDocumentsTo3C="api/FileManager/PushMergedDocumentsTo3C";
    getMergedFileHistory="api/FileManager/GetMergedFileHistory";
    GetUserList = 'api/ManageUser/GetUserList';
    getTypeOfParticipants="api/Project/GetTypeOfParticipant";
    changeParticipantColor="api/Project/ChangeParticipantColor";
    copyAFormFromAOffice="api/Project/CopyAFormFromAOffice";
    changeParticipantFromSignaturePage = "api/Project/ChangeParticipantFromSignaturePage";
    canThisPdfOpenforModifyByBytes="api/App/CanThisPdfOpenforModifyByBytes";
    canThisPdfOpenforModifyByUrl="api/App/CanThisPdfOpenforModifyByUrl";
    uploadPortalDocinChunks="portalapi/PortalDoc/UploadPortalDocinChunks";
    getPortalDocuments= "portalapi/PortalDoc/GetPortalDocuments";
    getPortalDocumentPages="portalapi/PortalDoc/GetPortalDocumentPages";
    updatePortalDocJson="portalapi/PortalDoc/UpdatePortalDocJson";
    renamePortalDocument="portalapi/PortalDoc/RenamePortalDocument";
    removePortalDocument="portalapi/PortalDoc/RemovePortalDocument";
    getStatusisDocReadyforSign="portalapi/PortalDoc/GetStatusisDocReadyforSign";
    getSNFDashboardCores="api/Dashboard/GetSNFDashboardCores";
    autoFillCoreDataintoProject="api/CoreDocument/AutoFillCoreDataintoProject";
    changeProcessStageForCore = "api/Dashboard/ChangeProcessStageForCore";
    getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
    AddCoreItemForPlaceholder = 'api/CoreDocument/AddCoreItemForPlaceholder';
    DownloadCoreDocument = "api/CoreDocument/DownloadDocument";
    FillPlaceholder = "api/CoreDocument/FillPlaceholder";
    getPDPMCores= "api/PDPM/GetPDPMCores";
    getPDPMStages="api/PDPM/GetPDPMStages";
  openEpisode = "api/PDPM/OpenEpisode";
  processRefreshAI = "api/Core/UpdatePDPMAIRunningStatus";
    changeMedicalCategoryForCore="api/PDPM/ChangeMedicalCategoryForCore";
    processNTAOnGivenDocuments="api/Core/ProcessNTAOnGivenDocuments";
    setCoreArchive = "api/Core/SetCoreArchive";
    setCoreActivate = "api/Core/SetCoreActivate";
    archiveEpisodes = "api/PDPM/ArchiveEpisode";
    coreMedicalStatsUpdate="api/PDPM/CoreMedicalStatsUpdate";
    addFavoriteItemForQuickLink="api/App/AddFavoriteItemForQuickLink";
    AddCreateProjectforPlaceholder = "api/CoreDocument/AddCreateProjectforPlaceholder";
    FavoriteCoreTransaction = 'api/CoreFavorite/AddCoreFavorite';
    FavoriteDeleteCoreTransaction = 'api/CoreFavorite/DeleteCoreFavorite';
      ImportantDeleteCoreTransaction = 'api/CoreFavorite/DeleteImportantCore';
  ImportantCoreTransaction = 'api/CoreFavorite/AddCoreImportant';
}

